import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';

// Один фильтр таблицы: выпадающий список с поиском по буквам, в нём можно отметить несколько названий
// (раньше это был столбик из галочек, у «Директора» их около ста). Размер поля обычный, как у списков в формах
// компании: у размера small подпись не стоит по центру поля.
function FilterDropdown({ label, options, value, onChange }) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      limitTags={2}
      getLimitTagsText={(more) => `+${more}`}
      options={options}
      value={value}
      onChange={(event, selected) => onChange(selected)}
      noOptionsText="Ничего не найдено"
      openText="Открыть список"
      closeText="Закрыть список"
      clearText="Очистить"
      ListboxProps={{ style: { maxHeight: 252 } }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox size="small" checked={selected} style={{ marginRight: 8, padding: 4 }} />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          placeholder={value.length ? '' : 'Все'}
        />
      )}
    />
  );
}

export default FilterDropdown;
